'use es6';

import { forwardRef, useRef, useLayoutEffect } from 'react';
import { getDOMNodeByMessageId } from '../operators/getDOMNodeByMessageId';
import ScrollWrapper from './ScrollWrapper';
import { componentFunctionInvariant } from '../operators/componentFunctionInvariant';
import { getMessageHistoryScrollingSnapshot } from '../operators/getMessageHistoryScrollingSnapshot';
import { scrollToMessageFactory, scrollToBottomFactory, scrollToBottomIfInThresholdFactory } from '../utilities/scrollUtilityFactories';
import { getSnapshotFields } from '../operators/getSnapshotFields';
import { jsx as _jsx } from "react/jsx-runtime";
export const withScrollTo = ScrollComponent => {
  componentFunctionInvariant(ScrollComponent, ['getScrollDistanceFromTop', 'getScrollDistanceFromBottom', 'setScrollTop', 'scrollToBottom']);
  const WithScrollTo = /*#__PURE__*/forwardRef((props, forwardedRef) => {
    const scrollWrapperRef = useRef();
    const snapshot = useRef();
    forwardedRef.current = {
      scrollToMessage: scrollToMessageFactory(),
      scrollToBottom: scrollToBottomFactory({
        scrollWrapperRef
      }),
      scrollToBottomIfInThreshold: scrollToBottomIfInThresholdFactory({
        scrollWrapperRef
      })
    };
    const componentJustMounted = useRef(true);
    useLayoutEffect(() => {
      const current = scrollWrapperRef.current;
      // dont run on mount
      if (componentJustMounted.current) {
        snapshot.current = getMessageHistoryScrollingSnapshot(current);
        componentJustMounted.current = false;
        return;
      }
      if (!snapshot.current) return;
      const {
        lastMessageId,
        lastMessageOffsetTop,
        prevScrollTop
      } = getSnapshotFields(snapshot);
      snapshot.current = getMessageHistoryScrollingSnapshot(current);
      if (current.getScrollDistanceFromTop() !== prevScrollTop) return;
      const lastDOMNode = getDOMNodeByMessageId(lastMessageId);
      if (!lastDOMNode || !lastDOMNode.offsetTop) return;
      const diff = lastDOMNode.offsetTop - lastMessageOffsetTop;
      if (diff) current.setScrollTop(current.getScrollDistanceFromTop() + diff);
    });
    return /*#__PURE__*/_jsx(ScrollWrapper, Object.assign({
      ref: scrollWrapperRef
    }, props));
  });
  WithScrollTo.displayName = 'WithScrollTo';
  return WithScrollTo;
};